import { reactive } from 'vue'
import type { Deliverable, DeliverableType, DeliverableStatus } from '@/types'

export interface DeliverablesState {
  deliverables: Deliverable[]
  selectedDeliverable: Deliverable | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    projectId: string
    type: DeliverableType | ''
    status: DeliverableStatus | ''
  }
}

export const getInitialState = (): DeliverablesState => ({
  deliverables: [],
  selectedDeliverable: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    type: '',
    status: '',
  },
})

export const createState = (): DeliverablesState => {
  return reactive(getInitialState())
}

export const resetState = (state: DeliverablesState): void => {
  const initial = getInitialState()
  state.deliverables = initial.deliverables
  state.selectedDeliverable = initial.selectedDeliverable
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
